import { useEffect, useState } from "react";
import { NavLink, Outlet, Link } from "react-router-dom";
import { Home, CalendarDays, UserPlus, Camera, Users, TreePalm, ALargeSmall } from "lucide-react";

const NAV = [
  { to: "/", label: "Home", icon: Home, id: "home" },
  { to: "/schedule", label: "Schedule", icon: CalendarDays, id: "schedule" },
  { to: "/register", label: "Register", icon: UserPlus, id: "register" },
  { to: "/photos", label: "Photos", icon: Camera, id: "photos" },
  { to: "/my-family", label: "My Family", icon: Users, id: "my-family" },
];

function useKupuna() {
  const [big, setBig] = useState(() => localStorage.getItem("fanene_big_text") === "1");
  useEffect(() => {
    document.documentElement.classList.toggle("kupuna", big);
    localStorage.setItem("fanene_big_text", big ? "1" : "0");
  }, [big]);
  return [big, setBig];
}

export default function PublicLayout() {
  const [big, setBig] = useKupuna();
  return (
    <div className="grain min-h-screen pb-28 md:pb-0">
      <header className="sticky top-0 z-40 bg-stone-900/90 backdrop-blur-md text-amber-50 border-b border-amber-900/40 shadow-md">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between gap-4">
          <Link to="/" data-testid="nav-brand-link" className="flex items-center gap-2 font-heading font-bold text-xl">
            <TreePalm className="w-7 h-7 text-amber-400" /> Fanene ʻĀiga
          </Link>
          <nav className="hidden md:flex items-center gap-1">
            {NAV.map((n) => (
              <NavLink key={n.id} to={n.to} end data-testid={`nav-${n.id}-link`}
                className={({ isActive }) => `px-4 py-2 rounded-full text-base font-semibold ${isActive ? "bg-amber-500 text-stone-900" : "hover:bg-white/10"}`}>
                {n.label}
              </NavLink>
            ))}
          </nav>
          <button data-testid="kupuna-mode-toggle" onClick={() => setBig(!big)} aria-pressed={big}
            className={`flex items-center gap-2 px-4 min-h-[44px] rounded-full border border-amber-200/40 font-semibold ${big ? "bg-amber-400 text-stone-900" : "hover:bg-white/10"}`}>
            <ALargeSmall className="w-5 h-5" /> <span className="text-sm">{big ? "Bigger text on" : "Bigger text"}</span>
          </button>
        </div>
      </header>

      <main className="relative z-10"><Outlet /></main>

      <footer className="relative z-10 max-w-6xl mx-auto px-6 py-12 text-stone-600 flex flex-wrap gap-6 justify-between">
        <p className="font-serif-accent italic">Faʻafetai lava — thank you for being part of our ʻāiga.</p>
        <Link to="/organizer/login" data-testid="nav-admin-link" className="underline font-semibold">Organizer sign-in</Link>
      </footer>

      <nav className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-white/95 backdrop-blur-md border-t-2 border-amber-900/15 grid grid-cols-5">
        {NAV.map((n) => (
          <NavLink key={n.id} to={n.to} end data-testid={`bottom-nav-${n.id}`}
            className={({ isActive }) => `flex flex-col items-center justify-center gap-1 py-3 text-xs font-bold ${isActive ? "text-[#8C3415] bg-[#FDF6ED]" : "text-stone-600"}`}>
            <n.icon className="w-6 h-6" />{n.label}
          </NavLink>
        ))}
      </nav>
    </div>
  );
}
